import React from 'react';

import Input from 'components/partials/input/input';

import { formatCount } from '../../helpers/results-format';

interface EditableEnrollmentCellProps {
  value: number;
  onChange: (value: number) => void;
  isDirty?: boolean;
  disabled?: boolean;
  originalValue?: number | null;
}

const EditableEnrollmentCell = ({
  value,
  onChange,
  isDirty,
  disabled,
  originalValue,
}: EditableEnrollmentCellProps) => {
  const [localValue, setLocalValue] = React.useState(String(value));
  const [isFocused, setIsFocused] = React.useState(false);
  const showOriginal = originalValue != null && Number.isFinite(originalValue);

  React.useEffect(() => {
    if (!isFocused) {
      setLocalValue(String(value));
    }
  }, [value, isFocused]);

  const handleCommit = () => {
    setIsFocused(false);
    const parsed = Number(localValue);

    if (Number.isNaN(parsed)) {
      setLocalValue(String(value));

      return;
    }

    const rounded = Math.round(parsed);

    if (rounded !== value) {
      onChange(rounded);
    } else {
      setLocalValue(String(rounded));
    }
  };

  return (
    <div className="flex flex-col gap-1">
      <Input
        value={localValue}
        placeholder="0"
        disabled={disabled}
        endAdornment={
          isDirty ? (
            <span className="size-1.5 rounded-full bg-navy-500" />
          ) : null
        }
        onChange={(e) => setLocalValue(e.target.value)}
        onFocus={() => setIsFocused(true)}
        onBlur={handleCommit}
        onKeyDown={(e) => {
          if (e.key === 'Enter') {
            e.currentTarget.blur();
          }
        }}
        inputCustomClass="py-1 text-sm"
        inputWrapperCustomClass="w-[70px] bg-white"
        aria-label="Enrollment override"
        data-testid="editable-enrollment-input"
      />
      {showOriginal && (
        <span className="text-xs text-gray-500">
          Original:{' '}
          <span className="font-medium">{formatCount(originalValue)}</span>
        </span>
      )}
    </div>
  );
};

export default EditableEnrollmentCell;
